// FE-SCRM-060 — <MoneyCell> currency formatter for table cells.
//
// Example:
//
//     <td><MoneyCell cents={opportunity.estimated_annual_revenue_cents} /></td>
//     <MoneyCell cents={50000n} />        // → "$500.00"
//     <MoneyCell cents={null} />          // → "—"
//
// Reads BigInt cents (the canonical money shape on the model). The
// host caller is responsible for converting the API's string payload
// (BigInt cents serialize as strings) to BigInt before passing in.


export type MoneyValue = bigint | number | null | undefined;


export function formatMoney(
  value: MoneyValue,
  currency = "USD",
): string {
  if (value === null || value === undefined) return "—";

  const num = typeof value === "bigint"
    ? Number(value) / 100
    : value / 100;

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
}


export interface MoneyCellProps {
  cents: MoneyValue;
  currency?: string;
  className?: string;
}


export function MoneyCell({
  cents, currency, className,
}: MoneyCellProps): JSX.Element {
  return (
    <span
      className={
        "tabular-nums "
        + (className ?? "")
      }
    >
      {formatMoney(cents, currency)}
    </span>
  );
}
